import { NgFor, NgForOf } from '@angular/common';
import { RouterLink } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { RaffleCardComponent } from '@components/raffle-card/raffle-card.component';
import { API_LIST, PosthogService } from '@core/services';
import { PosthogEvent, RaffleSimple } from '@core/models';

@Component({
  selector: 'app-not-found',
  templateUrl: './not-found.component.html',
  styleUrls: ['./not-found.component.scss'],
  imports: [RaffleCardComponent, NgFor, NgForOf, RouterLink],
  standalone: true
})
export class NotFoundComponent implements OnInit {
  public raffles: RaffleSimple[] = [];

  constructor(
    private httpClient: HttpClient,
    private posthogService: PosthogService
  ) {}

  ngOnInit(): void {
    this.loadRaffles();
    this.posthogService.capture(PosthogEvent.NotFound404);
  }

  loadRaffles() {
    this.httpClient
      .get(
        API_LIST.getRaffleDraws(
          'GBP',
          [],
          4,
          false,
          true,
          0,
          'date',
          'upcoming'
        )
      )
      .subscribe((raffles: RaffleSimple[]) => {
        this.raffles = raffles;
      });
  }
}
